(function () {
  'use strict';

  function absoluteUrl(url) {
    if (!url) return url;
    try {
      return new URL(url, document.baseURI).href;
    } catch (e) {
      return url;
    }
  }

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function initHeroParallax() {
    var hero = document.querySelector('.mt-hero');
    if (!hero) return;
    hero.classList.add('mt-reveal');
    requestAnimationFrame(function () {
      hero.classList.add('mt-visible');
    });
  }

  function initGaleria() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-principal] img');
      var minis = galeria.querySelectorAll('[data-mt-mini]');
      if (!principal || !minis.length) return;
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var full = mini.getAttribute('data-mt-full');
          var alt = mini.getAttribute('data-mt-alt') || '';
          if (!full) return;
          principal.setAttribute('src', full);
          principal.setAttribute('alt', alt);
          minis.forEach(function (m) { m.classList.remove('is-active'); });
          mini.classList.add('is-active');
        });
      });
    });
  }

  function initProducto() {
    var root = document.querySelector('[data-mt-producto]');
    if (!root) return;

    var variantsJson = root.querySelector('[data-mt-variants]');
    if (!variantsJson) return;
    var variants;
    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (e) {
      return;
    }

    var idInput = root.querySelector('[data-mt-variant-id]');
    var priceActual = root.querySelector('[data-mt-precio-actual]');
    var priceCompare = root.querySelector('[data-mt-precio-compare]');
    var badgeAhorro = root.querySelector('[data-mt-badge-ahorro]');
    var btnComprar = root.querySelector('[data-mt-btn-comprar]');
    var pills = root.querySelectorAll('[data-mt-pill]');
    var principal = root.querySelector('[data-mt-principal] img');
    var minis = root.querySelectorAll('[data-mt-mini]');
    var selected = {};

    var numOptions = 0;
    while (root.hasAttribute('data-mt-opcion-' + numOptions)) {
      var optName = root.getAttribute('data-mt-opcion-' + numOptions);
      var optVal = root.getAttribute('data-mt-valor-inicial-' + numOptions);
      if (optName && optVal) selected[optName] = optVal;
      numOptions++;
    }

    pills.forEach(function (pill) {
      if (pill.classList.contains('is-selected')) {
        selected[pill.getAttribute('data-mt-opcion')] = pill.getAttribute('data-mt-valor');
      }
    });

    function money(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
      });
    }

    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (val, i) {
          var optName = root.getAttribute('data-mt-opcion-' + i);
          return selected[optName] === val;
        });
      });
    }

    function actualizarDisponibilidad() {
      var opciones = {};
      pills.forEach(function (pill) {
        var opt = pill.getAttribute('data-mt-opcion');
        (opciones[opt] = opciones[opt] || []).push(pill);
      });
      Object.keys(opciones).forEach(function (opt) {
        opciones[opt].forEach(function (pill) {
          var valor = pill.getAttribute('data-mt-valor');
          var test = Object.assign({}, selected);
          test[opt] = valor;
          var existe = variants.some(function (v) {
            return v.options.every(function (val, i) {
              var optName = root.getAttribute('data-mt-opcion-' + i);
              return test[optName] === val;
            });
          });
          pill.disabled = !existe;
        });
      });
    }

    function actualizar() {
      var variant = findVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceActual) priceActual.textContent = money(variant.price);
      if (priceCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompare.textContent = money(variant.compare_at_price);
          priceCompare.style.display = '';
          if (badgeAhorro) {
            var ahorro = Math.round(100 - (variant.price / variant.compare_at_price) * 100);
            badgeAhorro.textContent = '-' + ahorro + '%';
            badgeAhorro.style.display = '';
          }
        } else {
          priceCompare.style.display = 'none';
          if (badgeAhorro) badgeAhorro.style.display = 'none';
        }
      }
      if (btnComprar) {
        if (variant.available) {
          btnComprar.disabled = false;
          btnComprar.textContent = btnComprar.getAttribute('data-mt-texto-disponible');
        } else {
          btnComprar.disabled = true;
          btnComprar.textContent = btnComprar.getAttribute('data-mt-texto-agotado');
        }
      }
      if (variant.image && principal) {
        var variantImageAbs = absoluteUrl(variant.image);
        principal.setAttribute('src', variant.image);
        minis.forEach(function (m) {
          m.classList.toggle('is-active', absoluteUrl(m.getAttribute('data-mt-full')) === variantImageAbs);
        });
      }
      actualizarDisponibilidad();
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        var opt = pill.getAttribute('data-mt-opcion');
        selected[opt] = pill.getAttribute('data-mt-valor');
        root.querySelectorAll('[data-mt-opcion="' + opt + '"]').forEach(function (p) {
          p.classList.remove('is-selected');
        });
        pill.classList.add('is-selected');
        actualizar();
      });
    });

    var cantidadInput = root.querySelector('[data-mt-cantidad-input]');
    root.querySelectorAll('[data-mt-cantidad-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!cantidadInput) return;
        var delta = parseInt(btn.getAttribute('data-mt-cantidad-btn'), 10);
        var val = Math.max(1, (parseInt(cantidadInput.value, 10) || 1) + delta);
        cantidadInput.value = val;
      });
    });

    actualizar();
  }

  function initUrgencia() {
    var els = document.querySelectorAll('[data-mt-urgencia]');
    if (!els.length) return;

    function madridNow() {
      var parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Madrid',
        hour12: false,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }).formatToParts(new Date());
      var map = {};
      parts.forEach(function (p) {
        map[p.type] = p.value;
      });
      var hora = map.hour === '24' ? '00' : map.hour;
      return new Date(map.year + '-' + map.month + '-' + map.day + 'T' + hora + ':' + map.minute + ':' + map.second);
    }

    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function actualizarUno(el) {
      var horaCorte = parseInt(el.getAttribute('data-mt-hora-corte'), 10);
      if (isNaN(horaCorte) || horaCorte < 0 || horaCorte > 23) horaCorte = 17;
      var ahora = madridNow();
      var corte = new Date(ahora.getTime());
      corte.setHours(horaCorte, 0, 0, 0);
      if (ahora.getTime() >= corte.getTime()) corte.setDate(corte.getDate() + 1);
      var restanteMs = corte.getTime() - ahora.getTime();
      var h = Math.floor(restanteMs / 3600000);
      var m = Math.floor((restanteMs % 3600000) / 60000);
      var s = Math.floor((restanteMs % 60000) / 1000);
      var span = el.querySelector('[data-mt-urgencia-tiempo]');
      if (span) span.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }

    function actualizarTodos() {
      els.forEach(actualizarUno);
    }

    actualizarTodos();
    setInterval(actualizarTodos, 1000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initHeroParallax();
    initGaleria();
    initProducto();
    initUrgencia();
  });
})();
